export const LEFT_ARROW_KEY_CODE = 37
export const RIGHT_ARROW_KEY_CODE = 39
export const ENTER_KEY_CODE = 13